<template>
    <div id="main">
        <div class="page">
            <loader v-if="isLoading" />
            <alert-container :messages="msgs" />
            <div class="novo-permissao">
                <h1 class="title">{{ $t('vinculo-usuario') }}</h1>
                <nav class="breadcrumb" aria-label="breadcrumbs">
                    <ul>
                        <li>
                            <a>{{ $t('colaborador') }}</a>
                        </li>
                        <li>
                            <a @click="$router.push({ name: 'usuario-vinculos' })">{{
                                $t('vinculo-usuario')
                            }}</a>
                        </li>
                        <li>
                            <a aria-current="page">{{ permissao.usuario.nome }}</a>
                        </li> 
                    </ul>
                </nav>

                <div class="columns">
                    <div class="column is-full">
                        <div class="descricao-input">
                            <v-input
                                ref="descricaoInput"
                                v-model="permissao.usuario.nome"
                                :id="'nome'"
                                :placeholder="'usuario-nome-placeholder'"
                                :maxlength="100"
                                :title="'usuario-nome'"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!permissao.usuario.nome"
                                :disabled="true"
                            />
                        </div>
                        <div class="assusuario">
                            <SelectUsuario v-if="permissao.usuarios" :list="permissao.usuarios" />
                        </div>
                    </div>
                </div>

                <div class="form-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="$router.push({ name: 'usuario-vinculos' })"
                    >
                        {{ $t('voltar') }}
                    </button>
                    <button
                        v-if="permission.update"
                        class="save-btn"
                        type="button"
                        @click="save()"
                        :disabled="isSaving"
                    >
                        {{ $t('salvar') }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PermissaoService from '@/services/PermissaoService';
import PermissaoValidation from '@/services/validations/PermissaoValidation';
import SelectUsuario from '@/components/colaborador/SelectUsuario';
import fSwitch from '@/components/shared/form/Switch.vue';
import Message from '@/models/Message';

export default {
    components: {
        fSwitch,
        SelectUsuario,
    },
    data() {
        return {
            isSaving: false,
            isLoading: false,
            permissao: {
                usuario: {},
            },
            editable: false,
            title: '',
            msgs: [],
        };
    },
    created() {
        this.permission = this.hasPermissionAccess('admin', 'colaborador', 'usuario-vinculos');
        if (!this.permission.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'vinculo-usuario' },
            });
        } else {
            if (this.permissao != null && this.permissao != {}) {
                this.editable = true;
            }

            this.service = new PermissaoService(this.$http, this.$router);
            this.validation = new PermissaoValidation(this.msgs);

            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados();
            }
        }
    },
    mounted() {
        this.$refs.descricaoInput.$refs.typed.focus();
    },
    methods: {
        carregarDados() {
            this.isLoading = true;
            this.permissao = {
                usuario: {},
            };
            this.$axios
                .get(`/authorization/${this.$route.params.id}.json?idClienteSovis=${this.$store.state.user.idClienteSovis}`)
                .then((body) => {
                    if (body.data.content) {
                        this.permissao = body.data.content;
                        this.title = this.permissao.usuario.nome;
                    } 
                    else {
                        this.$root.showMessage('error', 'msg-erro-load');
                    }
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        save() {
            // depreciado, pois nao se usa os fSwitch do HTML
            this.permissao = this.mapTosave(this.permissao);

            if (this.validation.validate(this.permissao, this.$refs)) {
                this.isSaving = true;
                this.service
                    .save(this.permissao)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-permissao-salva';
                            if (this.permissao.id) {
                                msg = 'msg-permissao-edita';
                            }
                            this.permissao = body.content;
                            this.msgs.push(new Message('success', msg, true));

                            // necessario recarregar a pagina, pois ao vincular ou nao um usuario
                            // precisa atualizar o restante do sistema com essas autalizacoes
                            location.reload();
                        } else {
                            if (this.$t(body.message)) {
                                this.msgs.push(new Message('alert', body.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                        this.isSaving = false;
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                        this.isSaving = false;
                    });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}

.page {
    position: relative;
    padding: 20px;
    background-color: $sovis-white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 2px;

    .assusuario {
        width: 100%;
        margin-top: 8px;
    }

    .novo-permissao {
        position: relative;
        width: 100%;
        height: 100%;
        padding-top: 0;

        h1.title {
            padding-top: 0;
        }
    }
}

.form-buttons {
    right: 0;
}

@media only screen and (min-width: 760px) {
    nav.breadcrumb {
        margin-right: 410px;
    }
}

.novo-permissao .center {
    width: 100%;
    left: 0;
    transform: translateX(0);
    margin: 0;
    box-sizing: border-box;
    position: initial;
    padding-bottom: 60px;
}

.novo-permissao .form {
    // display: block;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border-radius: 2px;
    text-align: left;

    .descricao-input {
        width: 100%;
    }
    .switch-permissoes {
        width: 100%;
        margin-top: 8px;
        display: flex;
        justify-content: space-between;
    }

    .location {
        width: 100%;
        height: auto;
        flex: 1 1 auto;
        margin-top: 20px;
        position: relative;
        min-height: 300px;
        height: auto;
        margin-bottom: 20px;

        .getlocation {
            position: absolute;
            margin-left: 0;
            bottom: -60px;
        }
    }
}
</style>
